<template>
  <div>
    <slot 
      :ready="ready"
      :processing="processing"
      :login="login"
      :withToken="withToken"
      :logout="logout"
      :authenticated="authenticated"
      :profile="profile">
    </slot>
  </div>
</template>

<script>
export default {
  props: {
    clientId: String
  },
  data() {
    return {
      ready: false,
      processing: false,
      authenticated: false,
      oauth2: undefined,
      tokenResp: undefined,
      profile: undefined,
      logoutTimer: undefined,
    }
  },
  methods: {
    login(scope, callback) {
      if (!(this.ready && this.clientId)) {
        console.error('Google API client not ready or clientId not provided');
        return;
      }

      this.processing = true;
      this.oauth2.initTokenClient({
        client_id: this.clientId,
        scope: scope || 'email profile https://www.googleapis.com/auth/drive.file',
        callback: (resp) => {
          this.handleToken(resp);
          if (callback) {
            callback(resp);
          }
        },
        error_callback: (err) => {
          this.processing = false;
          console.error('Token client error:', err);
        }
      }).requestAccessToken({ prompt: '' });
    },
    handleToken(resp) {
      console.log('Google token response:', resp);
      if (!resp) {
        return;
      }
      const now = Math.floor(Date.now() / 1000);
      if (!resp.created_at) {
        // New token
        resp.created_at = now;
      }
      const age = now - resp.created_at;
      if (age > resp.expires_in) {
        console.log("Google token is expired");
        this.logout();
        return;
      }
      // Logout when the token expires
      const msToExpiration = (resp.expires_in - age) * 1000;
      this.logoutTimer = setTimeout(this.logout, msToExpiration)

      localStorage.setItem('google_token', JSON.stringify(resp));
      this.tokenResp = resp;
      this.fetchUserProfile(resp.access_token);
      this.authenticated = true;
      this.processing = false;
    },
    async fetchUserProfile(token) {
      fetch('https://www.googleapis.com/oauth2/v2/userinfo?access_token=' + token)
        .then(response => response.json())
        .then(profile => {
          console.log('Google User Profile:', profile);
          this.profile = profile;
        })
        .catch(error => {
          console.error('Error fetching user profile:', error);
        })
    },
    withToken(scope, callback) {
      if (this.tokenResp && this.tokenResp.access_token && this.tokenResp.scope && this.tokenResp.scope.includes(scope)) {
        callback(this.tokenResp.access_token);
      }
      else {
        this.login(scope, (resp) => {
          if (resp && resp.access_token) {
            callback(resp.access_token);
          }
          else {
            console.error('Failed to obtain access token');
          }
        });
      }
    },
    logout() {
      this.authenticated = false;
      this.profile = null;
      if (this.authenticated && this.tokenResp && this.tokenResp.access_token) {
        this.oauth2.revoke(this.tokenResp.access_token);
      }
      localStorage.removeItem('google_token');
      this.tokenResp = null;
      if (this.logoutTimer) {
        clearTimeout(this.logoutTimer) 
      }
    }
  },
  mounted() {
    let script = document.createElement('script');
    script.setAttribute('src', 'https://accounts.google.com/gsi/client');
    script.onload = () => {
      this.oauth2 = window.google.accounts.oauth2;
      this.ready = true;
    };
    document.head.appendChild(script)

    try {
      this.handleToken(JSON.parse(localStorage.getItem('google_token')));
    }
    catch (err) {
      console.error('Error loading Google Token from local storage:', err);
    }
  }
}
</script>
